/*
  Voice of Armwrestling: shared site script.
  - VOA.library(): the video library JSON (fetched once, cached)
  - VOA.match(title, query): search with nicknames and small typos
  - VOA.card(v): a video card; clicking any .vv-card plays it on the site
  - Article embeds load YouTube only when the visitor presses play
*/
(function () {
  var VOA = window.VOA = window.VOA || {};

  // Nicknames people search for -> words that appear in video titles.
  var ALIASES = {
    jedi: ['janis', 'amolins'], janis: ['jedi'], amolins: ['jedi'],
    ray: ['liepins'], liepins: ['ray'],
    toddzilla: ['hutchings'], hutchings: ['toddzilla'],
    manifestor: ['telyatnik'], telyatnik: ['manifestor']
  };
  var STOP = ' armwrestling arm wrestling armwrestler with from that this what your vs the and for are you how why who was will can did does east west evw kott king table full live stream part video videos match matches round rounds new best top ';
  // Filler words dropped from search queries, so a typed question searches on its real words.
  var QUERY_STOP = ' a an the and or but of to in on at for from with without by about against into over under i me my mine we our you your he his she her it its they their them is are was were be been being am do does did doing have has had can could should would will shall may might must how what why when where who which whose this that these those there here get got getting make makes want need some any more most very really just so too also not no if then than as up down out off again please tips tip best way ways after before during guys guy people someone anyone vs versus ';
  // Words that are in almost every title: ignored when the query has other words.
  var QUERY_WEAK = ' armwrestling armwrestler armwrestlers arm arms wrestling video videos ';

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function near(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return false;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      var best = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return false;
      prev = cur;
    }
    return prev[b.length] <= max;
  }
  // One query word matches a normalised title: as a substring, through a nickname,
  // or as a near-miss of a whole title word ("laratt" finds "larratt").
  function termHit(term, text, words, exact) {
    if (text.indexOf(term) !== -1) return true;
    // Simple plurals and verb forms: "wrists" finds "wrist", "hurts" finds "hurt".
    if (term.length > 4 && term.slice(-1) === 's' && text.indexOf(term.slice(0, -1)) !== -1) return true;
    var alts = ALIASES[term] || [];
    for (var a = 0; a < alts.length; a++) if (text.indexOf(alts[a]) !== -1) return true;
    if (exact || term.length < 4) return false;
    for (var w = 0; w < words.length; w++) {
      var word = words[w];
      if (word.length < 4) continue;
      // Two typos for long words, or for 5-6 letter words that start the same ("larat" finds "larratt").
      var max = term.length >= 7 || (term.length >= 5 && word.slice(0, 2) === term.slice(0, 2)) ? 2 : 1;
      if (near(term, word, max)) return true;
    }
    return false;
  }
  VOA.norm = norm;
  VOA.esc = esc;
  VOA.terms = function (q) {
    var all = norm(q).split(' ').filter(Boolean);
    var real = all.filter(function (t) { return QUERY_STOP.indexOf(' ' + t + ' ') === -1; });
    if (!real.length) return all;
    var strong = real.filter(function (t) { return QUERY_WEAK.indexOf(' ' + t + ' ') === -1; });
    return strong.length ? strong : real;
  };
  VOA.score = function (title, terms, exact) {
    var text = norm(title), words = text.split(' '), s = 0;
    for (var k = 0; k < terms.length; k++) if (termHit(terms[k], text, words, exact)) s++;
    return s;
  };
  VOA.match = function (title, terms) {
    return VOA.score(title, terms) === terms.length;
  };
  // Filter a list by query. Up to 3 words: every word must match. A longer question: rank by
  // how many of its words match, keeping titles that hit at least 2 of them. If that finds
  // nothing, fall back to titles matching any one word; the result is flagged .loose.
  function ranked(items, terms, getText, need, exact) {
    return items.map(function (it, i) { return [VOA.score(getText(it), terms, exact), i, it]; })
      .filter(function (x) { return x[0] >= need; })
      .sort(function (a, b) { return b[0] - a[0] || a[1] - b[1]; })
      .map(function (x) { return x[2]; });
  }
  VOA.search = function (items, terms, getText) {
    if (!terms.length) return items.slice();
    var out = terms.length <= 3
      ? items.filter(function (it) { return VOA.match(getText(it), terms); })
      : ranked(items, terms, getText, 2);
    if (!out.length && terms.length > 1) {
      out = ranked(items, terms, getText, 1, true);
      out.loose = true;
    }
    return out;
  };

  VOA.fmtViews = function (n) {
    if (n >= 1e6) return (n / 1e6).toFixed(1).replace('.0', '') + 'M views';
    if (n >= 1e3) return (n / 1e3).toFixed(n >= 1e4 ? 0 : 1).replace('.0', '') + 'K views';
    return n + ' views';
  };
  // v = [id, title, date, views, duration, categories, playlists]
  VOA.card = function (v) {
    return '<a class="vv-card" href="https://www.youtube.com/watch?v=' + v[0] + '" data-id="' + v[0] + '">' +
      '<span class="vv-thumb"><img src="https://i.ytimg.com/vi/' + v[0] + '/mqdefault.jpg" alt="" loading="lazy" width="320" height="180">' +
      (v[4] ? '<span class="vv-dur">' + esc(v[4]) + '</span>' : '') + '</span>' +
      '<span class="vv-title">' + esc(v[1]) + '</span>' +
      '<span class="vv-meta">' + VOA.fmtViews(v[3]) + ' · ' + esc(v[2]) + '</span></a>';
  };

  var libPromise = null;
  VOA.library = function () {
    if (!libPromise) {
      libPromise = fetch(window.VOA_LIBRARY_URL).then(function (r) {
        if (!r.ok) throw new Error('library ' + r.status);
        return r.json();
      });
      libPromise.catch(function () { libPromise = null; });
    }
    return libPromise;
  };

  /* ---------- On-site player ---------- */
  var ICON_X = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 68 48" width="68" height="48" aria-hidden="true"><rect width="68" height="48" rx="12" fill="#e10600"/><path d="M27 15l17 9-17 9z" fill="#fff"/></svg>';
  VOA.ICON_PLAY = ICON_PLAY;
  var player, frame, titleEl, ytLink, moreWrap, moreGrid, lastFocus, currentId = null, pushed = false;

  function build() {
    player = document.createElement('div');
    player.className = 'voa-player';
    player.setAttribute('role', 'dialog');
    player.setAttribute('aria-modal', 'true');
    player.setAttribute('aria-labelledby', 'voa-player-title');
    player.hidden = true;
    player.innerHTML =
      '<div class="voa-player-box">' +
        '<div class="voa-player-top"><h2 id="voa-player-title" class="voa-player-title"></h2>' +
        '<button type="button" class="voa-player-close" aria-label="Close video">' + ICON_X + '</button></div>' +
        '<div class="voa-player-frame"></div>' +
        '<div class="voa-player-bar"><a class="voa-player-yt" target="_blank" rel="noopener">Open on YouTube</a></div>' +
        '<div class="voa-player-more" hidden><h3>Up next</h3><div class="voa-player-grid"></div></div>' +
      '</div>';
    document.body.appendChild(player);
    frame = player.querySelector('.voa-player-frame');
    titleEl = player.querySelector('.voa-player-title');
    ytLink = player.querySelector('.voa-player-yt');
    moreWrap = player.querySelector('.voa-player-more');
    moreGrid = player.querySelector('.voa-player-grid');
    player.querySelector('.voa-player-close').addEventListener('click', function () { close(); });
    player.addEventListener('click', function (e) { if (e.target === player) close(); });
    moreGrid.addEventListener('click', function (e) {
      var a = e.target.closest('.vv-card');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      open(a.dataset.id, a.querySelector('.vv-title').textContent, { replace: true });
    });
    player.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = player.querySelectorAll('button, a[href], iframe');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function urlWith(id) {
    var p = new URLSearchParams(location.search);
    if (id) p.set('v', id); else p.delete('v');
    var s = p.toString();
    return location.pathname + (s ? '?' + s : '') + location.hash;
  }

  function related(v, all) {
    var mine = norm(v[1]).split(' ').filter(function (w) { return w.length >= 4 && STOP.indexOf(' ' + w + ' ') === -1; });
    if (!mine.length) return [];
    var scored = [];
    for (var i = 0; i < all.length && scored.length < 400; i++) {
      var o = all[i];
      if (o[0] === v[0]) continue;
      var t = ' ' + norm(o[1]) + ' ', s = 0;
      for (var k = 0; k < mine.length; k++) if (t.indexOf(' ' + mine[k] + ' ') !== -1) s++;
      if (s) scored.push([s, i, o]);
    }
    scored.sort(function (a, b) { return b[0] - a[0] || a[1] - b[1]; });
    return scored.slice(0, 4).map(function (x) { return x[2]; });
  }

  function open(id, title, opts) {
    opts = opts || {};
    if (!player) build();
    if (!player.hidden && currentId === id) return;
    if (player.hidden) lastFocus = document.activeElement;
    currentId = id;
    titleEl.textContent = title || 'Voice of Armwrestling video';
    frame.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" title="' + esc(title || 'Video') + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
    ytLink.href = 'https://www.youtube.com/watch?v=' + id;
    moreWrap.hidden = true;
    player.hidden = false;
    document.documentElement.classList.add('voa-player-open');
    player.querySelector('.voa-player-close').focus();
    if (opts.push !== false) {
      if (opts.replace || pushed) history.replaceState({ voaV: id }, '', urlWith(id));
      else { history.pushState({ voaV: id }, '', urlWith(id)); pushed = true; }
    }
    VOA.library().then(function (d) {
      if (currentId !== id) return;
      var v = null;
      for (var i = 0; i < d.videos.length; i++) if (d.videos[i][0] === id) { v = d.videos[i]; break; }
      if (!v) return;
      if (!title) titleEl.textContent = v[1];
      var rel = related(v, d.videos);
      if (!rel.length) return;
      moreGrid.innerHTML = rel.map(VOA.card).join('');
      moreWrap.hidden = false;
    }).catch(function () {});
  }

  function close(fromPop) {
    if (!player || player.hidden) return;
    player.hidden = true;
    frame.innerHTML = '';
    currentId = null;
    document.documentElement.classList.remove('voa-player-open');
    if (!fromPop) {
      if (pushed) { pushed = false; history.back(); }
      else history.replaceState(null, '', urlWith(null));
    } else {
      pushed = false;
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  VOA.play = open;
  VOA.closePlayer = close;

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.vv-card[data-id], a[data-voa-play][data-id]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    if (player && player.contains(a)) return;
    e.preventDefault();
    var t = a.querySelector('.vv-title');
    open(a.dataset.id, t ? t.textContent : (a.dataset.title || ''));
  });
  window.addEventListener('popstate', function () {
    var id = new URLSearchParams(location.search).get('v');
    if (id && /^[\w-]{11}$/.test(id)) open(id, '', { push: false });
    else close(true);
  });

  /* ---------- Click-to-load article embeds ---------- */
  function facades() {
    var frames = document.querySelectorAll('iframe[data-voa-src]');
    Array.prototype.forEach.call(frames, function (f) {
      var src = f.getAttribute('data-voa-src');
      var m = src.match(/embed\/([\w-]{11})/);
      if (!m || m[1] === 'videoseries') { f.src = src; return; }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'voa-yt';
      b.setAttribute('aria-label', 'Play video: ' + (f.title || 'Voice of Armwrestling'));
      b.innerHTML = '<img src="https://i.ytimg.com/vi/' + m[1] + '/hqdefault.jpg" alt="" loading="lazy">' + ICON_PLAY +
        (f.title ? '<span class="voa-yt-title">' + esc(f.title) + '</span>' : '');
      b.addEventListener('click', function () {
        f.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&rel=0';
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        b.remove();
        f.focus();
      });
      f.parentNode.insertBefore(b, f);
    });
  }

  function ready() {
    facades();
    var id = new URLSearchParams(location.search).get('v');
    if (id && /^[\w-]{11}$/.test(id)) open(id, '', { push: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
